export default __webpack_public_path__ + "static/media/variable_expenses_3.bcd5b8a1.png";